/**
 * Avatars. The fallback is always initials on a neutral tile — never a broken
 * image, never a generic silhouette. SPEC.md §8.
 */

import { initials } from '../data';

// Props: { member, className (sizes/shapes the circle), title }

const BASE =
  'grid place-items-center overflow-hidden rounded-full bg-line font-market font-bold text-copy-muted';

/**
 * One component for every avatar surface: chat, mention dropdown, who's
 * going, department teams, the header profile button. The caller supplies
 * sizing classes; this only decides photo-vs-initials.
 */
export function Avatar({ member, className = '', title }) {
  return (
    <div className={`${BASE} ${className}`} title={title ?? member?.name ?? undefined}>
      {member?.photo ? (
        <img className="block h-full w-full rounded-full object-cover" src={member.photo} alt="" />
      ) : (
        initials(member?.name)
      )}
    </div>
  );
}

/**
 * Rectangular photo tiles (the ID card photo, the profile header). The
 * caller sizes the tile; `initialsClassName` styles the fallback initials.
 */
export function PhotoTile({ member, className = '', title, initialsClassName = '' }) {
  return (
    <div className={`grid place-items-center overflow-hidden ${className}`} title={title}>
      {member?.photo ? (
        <img className="h-full w-full object-cover" src={member.photo} alt="" />
      ) : (
        <div className={`font-market font-extrabold ${initialsClassName}`}>
          {initials(member?.name)}
        </div>
      )}
    </div>
  );
}
